<div class="wo-table-actions">
  <ng-content/>
</div>
